<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb :breadcrumbConfig="breadcrumbConfig"></breadcrumb>
    <div class="contentDetails c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; align-items: center">
            <img v-if="orderMessage.status == 1 ||
              orderMessage.status == 3 ||
              orderMessage.status == 4 ||
              orderMessage.status == 5 ||
              orderMessage.status == 6
              " src="../../../assets/icon_wait.png" style="margin-right: 8px" />
            <img v-if="orderMessage.status == 2" src="../../../assets/icon_guanbi.png" style="margin-right: 8px" />
            <img v-if="orderMessage.status == 7" src="../../../assets/icon_quxiao.png" style="margin-right: 8px" />
            <img v-if="orderMessage.status == 8" src="../../../assets/icon_wancheng.png" style="margin-right: 8px" />
            <span class="boldSize" v-if="orderMessage.status == 1">
              待审核
            </span>
            <span class="boldSize" v-if="orderMessage.status == 2">申请已驳回</span>
            <span class="boldSize" v-if="orderMessage.status == 3">申请已通过，待买家寄回商品</span>
            <span class="boldSize" v-if="orderMessage.status == 4">买家已寄回，待卖家签收</span>
            <span class="boldSize" v-if="orderMessage.status == 6">卖家已寄出换货商品，待买家签收</span>
            <span class="boldSize" v-if="orderMessage.status == 5">
              买家寄回商品已签收，待卖家换货寄出
            </span>
            <span class="boldSize" v-if="orderMessage.status == 7">
              售后申请已取消
            </span>
            <span class="boldSize" v-if="orderMessage.status == 8 && orderMessage.afterType == 0">已退款</span>
            <span class="boldSize" v-if="orderMessage.status == 8 && orderMessage.afterType == 1">售后完成，已成功退款</span>
            <span class="boldSize" v-if="orderMessage.status == 8 && orderMessage.afterType == 2">买家已签收</span>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; min-height: 120px">
        <div style="width: 14%; margin-top: 20px">
          <div v-if="orderMessage.status == 1" style="width: 300px">
            <div class="fontC">请及时审核！</div>
            <el-button style="margin-top: 10px" type="primary" size="small" plain @click="isApply = true">审核申请</el-button>
          </div>
          <div v-if="orderMessage.status == 2" style="width: 300px">
            <div class="fontC">驳回理由</div>
            <div class="fontC">
              {{ orderMessage.approveRemark }}
            </div>
          </div>
          <div v-if="orderMessage.status == 3" style="width: 300px">
            <div class="fontC">买家寄回中...</div>
            <el-button v-if="orderMessage.status == 3" type="primary" size="small" plain
              @click="outGoods('fedit')">填写退货单号</el-button>
          </div>
          <div v-if="orderMessage.status == 4">
            <div class="fontC">买家寄回中...</div>
            <div style="display: flex; flex-wrap: wrap; width: 300px">
              <div style="color: #4168e7" v-if="backInfo">
                {{ backInfo.logisticsCompanyLabel }}
              </div>
              <div style="color: #4168e7; margin-left: 10px; margin-left: 10px" v-if="backInfo">
                {{ backInfo.logisticsNumber }}
              </div>
            </div>
            <div style="display: flex;">
              <el-button size="small" style="margin-top: 10px" type="primary" plain @click="examine(1)">查看物流</el-button>
              <el-button size="small" style="margin-top: 10px" type="primary" plain
                @click="outGoods('tedit')">修改退货单号</el-button>
              <el-button size="small" style="margin-top: 10px" type="primary" @click="stock('five')">确认收货</el-button>
            </div>

          </div>
          <div v-if="orderMessage.status == 6" style="width: 300px">
            <div class="fontC">收货信息</div>
            <div style="display: flex; flex-wrap: wrap">
              <div style="color: #4168e7" v-if="backInfo">
                {{ backInfo.logisticsCompanyLabel }}
              </div>
              <div style="color: #4168e7; margin-left: 10px" v-if="backInfo">
                {{ backInfo.logisticsNumber }}
              </div>
            </div>
            <el-button size="small" style="margin-top: 10px" type="primary" plain @click="examine(2)">查看物流</el-button>
            <el-button size="small" type="primary" @click="outGoods('hedit')" plain>修改换货单号</el-button>
            <el-button size="small" type="primary" @click="stock('five')">确认收货</el-button>
          </div>
          <div v-if="orderMessage.status == 5" style="width: 300px">
            <div class="fontC">出货信息</div>
            <div class="fontC">等待寄出换货</div>
            <el-button v-if="orderMessage.status == 5" size="small" plain type="primary"
              @click="outGoods('delivery')">寄出换货</el-button>
          </div>
          <div v-if="orderMessage.status == 7" style="width: 300px">
            <div class="fontC">用户已手动取消售后申请！</div>
            <div class="fontC">时间: {{ orderMessage.createdTime }}</div>
          </div>
          <div v-if="orderMessage.status == 8 && orderMessage.afterType == 0" style="width: 300px">
            <div class="fontC">退款金额已退回买家账户！</div>
          </div>
          <div v-if="orderMessage.status == 8 && orderMessage.afterType == 1" style="width: 300px">
            <div class="fontC">完成时间：{{ orderMessage.completeTime }}</div>
          </div>
          <div v-if="orderMessage.status == 8 && orderMessage.afterType == 2" style="width: 300px">
            <div class="fontC">买家成功签收，售后已完成！</div>
            <div style="display: flex; flex-wrap: wrap">
              <div style="color: #4168e7" v-if="backInfo">
                {{ backInfo.logisticsCompanyLabel }}
              </div>
              <div style="color: #4168e7; margin-left: 10px" v-if="backInfo">
                {{ backInfo.logisticsNumber }}
              </div>
            </div>
            <el-button size="small" style="margin-top: 10px" type="primary" plain @click="examine(2)">查看物流</el-button>

            <!-- <div class="fontC">
              <div style="display: flex; flex-wrap: wrap">
                <div v-if="backInfo">
                  物流公司：{{ backInfo.logisticsCompanyLabel }}
                </div>
                <div v-if="backInfo">
                  物流订单：{{ backInfo.logisticsNumber }}
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div style="
            width: 0px;
            height: 124px;
            border: 1px dashed #ebebfa;
            opacity: 1;
            margin-left: 67px;
            margin-right: 41px;
          "></div>
        <div style="width: 90%">
          <Steps v-if="orderMessage.afterType == 0" :stepInfo="statusNode"></Steps>
          <Steps1 v-if="orderMessage.afterType == 1" :stepInfo="statusNode"></Steps1>
          <Steps2 v-if="orderMessage.afterType == 2" :stepInfo="statusNode"></Steps2>
        </div>
      </div>
    </div>

    <!-- 订单信息 -->
    <div class="contentDetails">
      <div class="title" style="display: flex; align-items: center">
        订单信息
        <!-- <div class="saleAfterType">
          {{ orderMessage.orderTypeLabel }}
        </div> -->
      </div>
      <div class="order_details">
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">订单编号</span><span class="order_details_value"
              v-if="orderMessage.orderInfo">{{
                orderMessage.orderInfo.orderNo
                ? orderMessage.orderInfo.orderNo
                : "-"
              }}</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">订单类型</span><span class="order_details_value"
              v-if="orderMessage.orderInfo">{{
                orderMessage.orderInfo.orderTypeLabel
                ? orderMessage.orderInfo.orderTypeLabel
                : "-"
              }}</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">支付方式</span><span class="order_details_value">在线支付</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">支付时间</span><span class="order_details_value"
              v-if="orderMessage.orderInfo">{{
                orderMessage.orderInfo.payTime
                ? orderMessage.orderInfo.payTime
                : "-"
              }}</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">来源类型</span><span class="order_details_value"
              v-if="orderMessage.orderInfo">{{ orderMessage.orderInfo.originTypeLabel
                ? orderMessage.orderInfo.originTypeLabel
                : "-" }}</span>
          </div>
        </div>
        <!-- <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">订单分类</span><span class="order_details_value">自动单</span>
          </div>
        </div> -->
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">备注信息</span><span class="order_details_value"
              v-if="orderMessage.orderInfo">{{
                orderMessage.orderInfo.userRemark
              }}</span>
          </div>
        </div>
      </div>
      <div style="
          width: 100%;
          height: 0px;
          border: 1px dashed #ebebfa;
          opacity: 1;
          margin-top: 14px;
        "></div>
      <div class="title" style="margin-top: 24px">购买信息</div>
      <div class="contentDetails_box">
        <div class="contentDetails_item" style="display: flex">
          <div class="title_too">收货信息</div>
          <div class="details">
            <div class="details_item">
              <span class="details_title fourteen" style="margin-left: -24px">收货人</span><span
                class="details_value fourteen" v-if="orderMessage.orderInfo">{{
                  orderMessage.orderInfo.postName
                  ? orderMessage.orderInfo.postName
                  : "-"
                }}</span>
            </div>
            <div class="details_item">
              <span class="details_title fourteen">联系方式</span><span class="details_value fourteen"
                v-if="orderMessage.orderInfo">{{
                  orderMessage.orderInfo.postPhone
                  ? orderMessage.orderInfo.postPhone
                  : "-"
                }}</span>
            </div>
            <div class="details_item addressWidth">
              <span class="details_title fourteen">收货地址</span><span class="details_value fourteen"
                v-if="orderMessage.orderInfo">{{ orderMessage.orderInfo.postDistrictAddress }}&nbsp;{{
                  orderMessage.orderInfo.postAddress
                }}</span>
            </div>
          </div>
        </div>
        <div class="contentDetails_item" style="display: flex">
          <div class="title_too" style="margin-left: 100px">买家信息</div>
          <div class="details">
            <div class="details_item">
              <span class="details_title fourteen" style="margin-left: -10px">客户姓名</span><span
                class="details_value fourteen" v-if="orderMessage.orderInfo">{{
                  orderMessage.orderInfo.userName
                  ? orderMessage.orderInfo.userName
                  : "-"
                }}</span>
            </div>
            <div class="details_item">
              <span class="details_title fourteen">客户电话</span><span class="details_value fourteen"
                v-if="orderMessage.orderInfo">{{
                  orderMessage.orderInfo.userPhone
                  ? orderMessage.orderInfo.userPhone
                  : "-"
                }}</span>
            </div>
            <div class="details_item">
              <span class="details_title fourteen">来源平台</span><span class="details_value fourteen"
                v-if="orderMessage.orderInfo">{{
                  orderMessage.orderInfo.miniAppName
                  ? orderMessage.orderInfo.miniAppName
                  : "-"
                }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="contentDetails_item" style="display: flex">
          <div class="title_too" style="margin-left: 100px">来源平台</div>
          <div class="details">
            <div class="details_item">
              <span class="details_value fourteen" v-if="orderMessage.orderInfo">{{
                orderMessage.orderInfo.miniAppName
                ? orderMessage.orderInfo.miniAppName
                : "-"
              }}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="contentDetails">
      <div class="titleBtn">
        <div class="title" style="margin-bottom: 20px">
          <label>商品信息</label>
        </div>
      </div>
      <el-table :data="orderAfterDetailList1" :header-cell-style="{ background: '#fafafa', color: '#333333' }">
        <el-table-column prop="updatedTime" label="商品信息" headerAlign="left">
          <template slot-scope="props">
            <div style="text-align: left">
              <div>
                <span>{{
                  props.row.goodsName ? props.row.goodsName : "-"
                }}</span>
              </div>
              <p>{{ props.row.goodsSkuName ? props.row.goodsSkuName : "-" }}</p>
              <p>
                商品编码：{{
                  props.row.goodsSkuNo ? props.row.goodsSkuNo : "-"
                }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="单价/数量" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>
                ￥{{
                  Number(props.row.retailPrice).toFixed(2) ||
                  Number(props.row.unitPrice).toFixed(2)
                }}
              </p>
              <p>×&nbsp;{{ props.row.afterQuantity }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="运费" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>￥{{ Number(props.row.freightAmount).toFixed(2) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="优惠" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>￥{{ Number(orderMessage.discountAmount).toFixed(2) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="小计" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              <p>实付￥{{ Number(props.row.refundMoney).toFixed(2) }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <div class="fourteenDetails_title">优惠信息</div>
      <div v-if="orderMessage.discountLabel">
        <p>{{ orderMessage.discountLabel }}</p>
      </div>
      <template v-else>
        <div class="fourteenDetails" style="
            margin-top: 12px;
            border-bottom: 1px solid #ededed;
            padding-bottom: 20px;
          ">
          无优惠
        </div>
      </template> -->
      <div class="titleBtn" v-if="orderMessage.afterType == 0 && orderAfterDetailList2.length != 0">
        <div class="title" style="margin-top: 20px; margin-bottom: 20px">
          <label>赠品商品</label>
        </div>
      </div>
      <el-table v-if="orderMessage.afterType == 0 && orderAfterDetailList2.length != 0" :data="orderAfterDetailList2"
        :header-cell-style="{ background: '#fafafa', color: '#333333' }">
        <el-table-column prop="updatedTime" label="商品信息" headerAlign="left">
          <template slot-scope="props">
            <div style="text-align: left">
              <div>
                <span>{{
                  props.row.goodsName ? props.row.goodsName : "-"
                }}</span>
              </div>
              <p>{{ props.row.goodsSkuName ? props.row.goodsSkuName : "-" }}</p>
              <p>
                商品编码：{{
                  props.row.goodsSkuNo ? props.row.goodsSkuNo : "-"
                }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="单价/数量" header-align="center">
          <template slot-scope="props">
            <div style="text-align: center">
              <p>
                ￥{{
                  Number(props.row.retailPrice).toFixed(2) ||
                  Number(props.row.unitPrice).toFixed(2)
                }}
              </p>
              <p>×&nbsp;{{ props.row.afterQuantity }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="小计" header-align="center">
          <template slot-scope="props">
            <div style="text-align: center">
              <p>实付￥{{ Number(props.row.refundMoney).toFixed(2) }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="total_prices">
        <span style="color: #666666; margin-right: 15px"
          v-if="orderMessage.orderInfo && orderMessage.afterType == 0">商品总价：￥{{
            Number(orderMessage.orderInfo.goodsAmount).toFixed(2) || "0.00"
          }}</span>
        <span style="color: #666666; margin-right: 15px" v-if="(orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
            ">商品总价：￥{{
      Number(
        orderMessage.orderAfterDetailList[0].retailPrice *
        orderMessage.orderAfterDetailList[0].afterQuantity
      ).toFixed(2) || "0.00"
    }}</span>
        <span style="color: #666666; margin-right: 15px"
          v-if="orderMessage.orderInfo && orderMessage.afterType == 0">运费：￥{{
            Number(orderMessage.orderInfo.freightAmount).toFixed(2) || "0.00"
          }}</span><!-- 暂时咩有 -->
        <span style="color: #666666; margin-right: 15px" v-if="(orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
            ">运费：￥{{
      Number(orderMessage.orderAfterDetailList[0].freightAmount).toFixed(
        2
      ) || "0.00"
    }}</span>
        <span style="color: red; margin-right: 15px">优惠：￥{{
          orderMessage.discountAmount
          ? Number(orderMessage.discountAmount).toFixed(2)
          : "0.00"
        }}</span><!-- 暂时咩有 -->
        <span style="color: #444; margin-right: 15px" v-if="orderMessage.afterType == 0">应付：￥{{
          Number(orderMessage.refundMoney).toFixed(2) }}</span>
        <span style="color: #444; margin-right: 15px" v-if="(orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
          orderMessage.orderAfterDetailList
          ">应付：￥{{
    Number(
      orderMessage.orderAfterDetailList[0].refundMoney +
      orderMessage.orderAfterDetailList[0].freightAmount
    ).toFixed(2)
  }}</span>
        <span style="color: #6190ed; margin-right: 15px">（实付：￥{{ Number(orderMessage.refundMoney).toFixed(2) }}）</span>
        <!-- <span
          style="color: #6190ed; margin-right: 15px"
          v-if="
            (orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
          "
          >（实付：￥{{
            Number(
              orderMessage.orderAfterDetailList[0].refundMoney +
                orderMessage.orderAfterDetailList[0].freightAmount
            ).toFixed(2)
          }}）</span
        > -->
        <span style="color: red" v-if="orderMessage.afterType == 0 || orderMessage.afterType == 1">应退款金额：￥{{
          Number(orderMessage.refundMoney).toFixed(2) }}</span>
        <!-- <span
          style="color: red"
          v-if="
            orderMessage.afterType == 1 && orderMessage.orderAfterDetailList
          "
          >应退款金额：￥{{
            Number(orderMessage.orderAfterDetailList[0].refundMoney).toFixed(2)
          }}</span
        >  -->
      </div>
      <div style="
          border: 1px dashed #ebebfa;
          margin-top: 25px;
          margin-bottom: 24px;
        "></div>
      <div>
        <label class="afterTitle">售后信息</label>
        <div style="display: flex">
          <div>
            <el-form :inline="true" label-position="left">
              <el-form-item label="售后编号" style="width: 100%">
                <div class="afterInfo">{{ orderMessage.afterNo }}</div>
              </el-form-item>
              <el-form-item label="售后类型" style="width: 100%">
                <div class="afterInfo">{{ orderMessage.afterTypeLabel }}</div>
              </el-form-item>
              <el-form-item label="售后原因" style="width: 100%">
                <div class="afterInfo">{{ orderMessage.afterReasonLabel }}</div>
              </el-form-item>
              <el-form-item label="售后说明" style="width: 100%">
                <div class="afterInfo">{{ orderMessage.afterRemark }}</div>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-form :inline="true">
              <el-form-item label="售后图片">
                <el-image v-for="(item, index) in imgs" :key="index" style="
                    width: 118px;
                    height: 118px;
                    border-radius: 3px;
                    margin-top: 8px;
                    margin-left: 10px;
                    cursor: pointer;
                  " @click="look(item)" :src="item" lazy></el-image>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="orderMessage.afterType != 2" style="
            float: right;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #f63c56;
          ">
          <div v-if="orderMessage.status == 1 ||
            orderMessage.status == 2 ||
            orderMessage.status == 7 ||
            orderMessage.status == 3 ||
            orderMessage.status == 4 ||
            orderMessage.status == 5
            ">
            已退款金额：￥0.00
          </div>
          <div v-else>
            已退款金额：￥{{
              orderMessage.refundMoney
              ? Number(orderMessage.refundMoney).toFixed(2)
              : "0"
            }}
          </div>
        </div>
        <div
          v-if="orderMessage.afterType !== 0 && !(orderMessage.status == 1 || orderMessage.status == 2 || orderMessage.status == 7)"
          style="
            border: 1px dashed #ebebfa;
            margin-top: 44px;
            margin-bottom: 24px;
          "></div>
        <div v-else style="margin-top: 24px"></div>
        <label class="afterTitle" style="margin-top: 24px"
          v-if="orderMessage.afterType !== 0 && !(orderMessage.status == 1 || orderMessage.status == 2 || orderMessage.status == 7)">寄回信息</label>
        <div style="display: flex"
          v-if="orderMessage.afterType !== 0 && !(orderMessage.status == 1 || orderMessage.status == 2 || orderMessage.status == 7)">
          <div>
            <el-form :inline="true" label-position="right" label-width="86px">
              <el-form-item label="退回地址" style="width: 100%">
                <span v-if="backInfo1" class="afterInfo">{{
                  backInfo1.postAddress
                }}</span>
              </el-form-item>
              <el-form-item label="退货电话" style="width: 100%">
                <span v-if="backInfo1" class="afterInfo">{{
                  backInfo1.postContact
                }}</span>
              </el-form-item>
              <el-form-item label="退货联系人" style="width: 100%">
                <span v-if="backInfo1" class="afterInfo">{{
                  backInfo1.postName
                }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="botton_btn">
      <el-button type="info" @click="back()">返回</el-button>
    </div>
    <el-dialog :append-to-body="true" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width"
      :before-close="handleClose" :close-on-click-modal="false">
      <!-- 查看物流 -->
      <template v-if="dialog.type == 'logisticsInformation'" class="VerticalSteps">
        <StepLogistics :stepProgress="logisticsNode"></StepLogistics>
      </template>
      <!-- 发货弹框 -->
      <template v-if="dialog.type == 'shipmentsCode'">
        <el-form ref="wuliu" :model="wuliu" :rules="wuliuRules" label-width="80px">
          <el-form-item label="出库仓库" label-width="100px" prop="warehouse">
            <el-select filterable v-model="wuliu.warehouse" placeholder="请选择出库仓库" style="width: 100%">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in commWarehouseList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流公司" label-width="100px" prop="company">
            <el-select filterable v-model="wuliu.company" placeholder="请选择物流公司" style="width: 100%">
              <el-option :label="item.dictName" :value="item.dictId" v-for="(item, index) in dictionaries.courier_company"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" label-width="100px" prop="odd">
            <el-input oninput="value=value.replace(/[^\w_]/g,'')" v-model.trim="wuliu.odd"></el-input>
          </el-form-item>
          <div class="dialogBtn">
            <el-button @click="dialog.visible = false">取 消</el-button>
            <el-button type="primary" @click="dialogSubmitwuliu('wuliu')">确 定</el-button>
          </div>
        </el-form>
      </template>
      <!-- 新增收货地址 -->
      <template v-if="dialog.type == 'addAddress'" class="addAddress">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="收货人姓名" label-width="100px" prop="userName">
            <el-input v-model.trim="form.userName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" label-width="100px" prop="phone">
            <el-input oninput="value=value.replace(/[^0-9.]/g,'')" :maxLength="11" v-model.trim="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="收货地址" label-width="100px" prop="addressValue">
            <el-cascader v-model="form.addressValue" :options="addressOptions" clearable filterable
              @change="onChangeAddress"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" label-width="100px" prop="detailedAddress">
            <el-input v-model.trim="form.detailedAddress"></el-input>
            <el-checkbox v-model="form.isDefault" :false-label="0" :true-label="1">设为默认
            </el-checkbox>
          </el-form-item>
          <div class="dialogBtn">
            <el-button @click="dialog.visible = false">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit('form')">确 定</el-button>
          </div>
        </el-form>
      </template>
      <!-- 添加备注 -->
      <template v-if="dialog.type == 'addRemark'">
        <el-form label-width="50px">
          <el-form-item label="备注">
            <el-input type="textarea" :rows="5" placeholder="请输入备注" v-model="remark">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="dialogBtn">
          <el-button @click="dialog.visible = false">取 消</el-button>
          <el-button type="primary" @click="confirmAddRemark">确 定</el-button>
        </div>
      </template>
      <!-- 修改默认地址 -->
      <template v-if="dialog.type == 'addressAmend'">
        <span class="addressHeader">
          <i class="el-icon-circle-plus-outline" style="color: #4168e7"></i>
          <el-button style="color: #4168e7" type="text" @click="addAddress('Address')">新增收货地址</el-button>
        </span>
        <el-table :data="siteDataList" :header-cell-style="{ background: '#F8F8F9', color: '#333333' }">
          <el-table-column label="收货人" prop="userName"></el-table-column>
          <el-table-column label="手机号码" prop="phone"></el-table-column>
          <el-table-column label="地区" prop="userName">
            <template slot-scope="props">
              <p>
                {{
                  props.row.provinceCode
                  ? props.row.provinceCode +
                  props.row.cityCode +
                  props.row.regionCode
                  : "-"
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="详细地址" prop="detailedAddress">
          </el-table-column>
          <el-table-column label="默认地址">
            <template slot-scope="props">
              <el-switch v-model="props.row.isDefault" :active-value="1" :inactive-value="0"
                @change="defaultSite(props.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="props">
              <el-button type="text" @click="employ(props.row)">使用
              </el-button>
              <el-button type="text" @click="dialogEdit('editAddress', props.row)">编辑
              </el-button>
              <el-button style="color: red" type="text" @click="dialogDelete(props.row.id)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
    <!-- 售后 -->
    <el-dialog title="售后申请" :visible.sync="isApply" width="40%" :append-to-body="true">
      <template>
        <div class="info">是否审核通过？</div>
        <div style="margin-top: 18px">
          <el-radio-group v-model="status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </div>
        <div v-if="status == 1 && orderMessage.afterType == 0" class="pass">
          确认后，金额<span style="color: #f63c56">￥{{ orderMessage.refundMoney }}</span>将退回买家账户
        </div>
        <div v-if="status == 1 && orderMessage.afterType != 0" style="margin-top:10px">
          <el-table :data="gridData" border @row-click="rowClick" v-if="status == 1">
            <el-table-column prop="select" width="50">
              <template slot-scope="scope">
                <el-radio v-model="radioIdSelect" :label="scope.row.id">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="收货人姓名" width="200">
            </el-table-column>
            <el-table-column prop="phone" label="收货人电话" width="200">
            </el-table-column>
            <el-table-column prop="address" label="收货地址"> </el-table-column>
          </el-table>
        </div>
        <div v-if="status == 2" style="margin-top: 24px; width: 90%; margin-bottom: 24px">
          <div style="display: flex">
            <div style="margin-right: 8px; width: 10%">备注</div>
            <div style="width: 90%">
              <el-input v-model="remark" type="textarea" style="width: 100%" placeholder="请输入备注" maxlength="200"
                show-word-limit rows="5">
              </el-input>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isApply = false">取消</div>
          <div class="info-s" @click="submitApply()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" append-to-body>
      <img width="100%" fit="contain" :src="dialogImageUrl" alt="" style="width: 100%" />
    </el-dialog>
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body width="40%">
      <div style="margin-bottom: 10px">
        <el-form ref="dialogForm" :model="dialogForm" label-width="80px" :rules="rules1">
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-select style="width: 100%" v-model="dialogForm.logisticsCompany" placeholder="请选择物流公司" filterable>
              <el-option v-for="(item, index) in dictionaries.courier_company" :key="index" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input v-model="dialogForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogVisible = false">取消</div>
        <div class="info-s" @click="submit">确定</div>
      </div>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isInfo" width="518px" :append-to-body="true">
      <template>
        <div style="font-size: 20px">是否确认收货?</div>
        <div v-if="this.typeI == 'user'">
          请确认平台用户是否收货，该操作不可修改！
        </div>
        <div v-else>请确认仓库收货，该操作不可修改！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isInfo = false">取消</div>
          <div class="info-s" @click="submitInfo">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import LbTable from '../../../components/lb-table/lb-table'
import Steps from '../../../components/zws-steps.vue'
import Steps1 from '../../../components/zws-steps1.vue'
import Steps2 from '../../../components/zws-steps2.vue'
import breadcrumb from '@/components/breadcrumb'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import VerticalSteps from '../../../components/vertical-steps.vue'
import uploadPicture from '@/components/upload/picture.vue'
import StepLogistics from '../components/StepLogistics.vue'
import addressData from '@/components/addressData.js'
import mixinsCommon from '../mixins/common'
export default {
  mixins: [mixinsCommon],
  name: 'orderDetails',
  components: {
    LbTable,
    Steps,
    Steps1,
    Steps2,
    breadcrumb,
    breadcrumbSearch,
    VerticalSteps,
    uploadPicture,
    StepLogistics
  },
  data() {
    return {
      radioIdSelect: '',
      gridData: [],
      addressInfo: {
        name: '',
        phone: '',
        address: ''
      },
      isInfo: false,
      typeI: '',
      title: '发货',
      dialogForm: {
        logisticsCompany: '',
        logisticsNumber: '',
      },
      rules1: {

        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      dialogVisible1: false,
      dialogVisible: false,
      dialogImageUrl: '',
      imgs: [],
      isApply: false,
      status: 1,
      remark: '',
      loading: false,
      orgName: '', //
      userId: '', //
      afterMoney: '', // 单个商品的退款金额
      multipleSelectionList: '',
      wuliu: {
        warehouse: '',
        company: '',
        odd: ''
      },
      lastTime: '0', // 防抖使用
      logistics: '', // 从物流页面进入
      shenheState: '', // 有值表示从审核页面进入
      selectShenhe: '', // 是否审核通过
      transactionRecord: [], // 交易记录
      paymentAmount: '', // 在线支付金额
      totalQuantity: 0, // 商品总数量
      totalPrices: '', // 商品总价
      closeMessage: '', // 关闭订单信息
      logisticsNode: {}, // 物流节点信息
      auditStatus: '', // 审核状态
      orderNo: '', // 订单编号
      statusNode: {}, // 状态节点
      rowId: '', // 地址ID
      addressOptions: [], // 地区 options
      multipleSelection: [], // 售后弹框列表单选选值
      siteDataList: '', // 收获地址列表数据
      goodsMessage: [], // 获取订单商品信息
      goodsListDialog: [], // 弹窗订单商品信息
      logisticsMessage: '', // 物流公司及物流单号
      buyMessage: '', // 购买信息
      orderId: '', // 订单ID
      orderMessage: '', // 订单信息
      cause: '',
      setPay: {
        payDefault: '', // 设为默认
        payment: ''
      },
      payMoney: '', // 支付金额

      // 新增收货地址参数
      form: {
        userName: '', // 姓名
        phone: '', // 联系电话
        provinceCode: '', // 省
        cityCode: '', // 市
        regionCode: '', // 区
        detailedAddress: '', // 详细地址
        addressValue: [],
        isDefault: 0
      },
      ruleForm: {
        afterSaleReason: '', // 售后原因（字典分组：after_sale_reason）	body	true	integer(int32)
        afterType: '', // 售后类型（字典分组：after_type）	body	true	integer(int32)
        appendixList: [], //	退款凭证记录（附件）列表	body	false	array	售后订单退款凭证
        customerUserId: '', //	退货客户id	body	true	integer(int64)
        orderId: '', //	订单id	body	true	integer(int64)
        refundExplain: '', //	退款说明	body	false	string
        refundMoney: '', //	退款金额	body	true	number
        sysUserId: '', //	跟进客服id	body	true	integer(int64)
        totalNum: '' //	总数量	body	true	integer(int64)
      },
      // 新增收货地址参数校验
      rules: {
        userName: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error('请输入中文'))
              } else {
                // 校验通过
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 6, max: 11, message: '手机号码少于6位超过11位', trigger: 'blur' }
        ],
        addressValue: [
          { required: true, message: '请选择地址', trigger: 'change' }
        ],
        detailedAddress: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ]
      },
      rulesRuleForm: {
        afterType: [
          { required: true, message: '请选择退款类型', trigger: 'change' }
        ],
        afterSaleReason: [
          { required: true, message: '请选择售后原因', trigger: 'change' }
        ],
        refundMoney: [
          { required: true, message: '请选择输入退款金额', trigger: 'blur' }
        ]
      },
      orderAfterDetailList1: [],
      orderAfterDetailList2: [],
      // 发货相关弹框参数开始
      shipmentsForm: {

      },
      wuliuRules: { // 表格验证
        warehouse: [
          { required: false, message: '请选择出货仓库', trigger: 'change' }
        ],
        company: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        odd: [
          { required: true, message: '请填写物流单号', trigger: 'blur' }
        ]
      },
      // 发货相关弹框参数结束
      shenhe: '2', // 审核
      setCloseOrder: '', // 关闭订单

      dialog: { visible: false, title: '', type: '', width: '' },
      dialogToo: { visible: false, title: '', type: '', width: '' },
      dialogAfterSale: { visible: false, title: '', type: '', width: '' }, //
      searchList: {
        list: [
          { title: '订单详情', path: '', type: '0' }
        ]
      },
      breadcrumbConfig: {
        list: [
          {
            title: '售后订单',
            type: '#ff0000',
            path: '/orderManagement/afterOrderList'
          },
          {
            title: '订单详情',
            type: '1'
          }

        ]
      },
      remark: '',
      activeNum: 2,
      roleForm: {
        name: ''
      },
      columnRecord: [

        {
          label: '交易订单号',
          prop: 'tradingNo'

        }, {
          label: '支付类型',
          prop: 'payTypes'
        },
        {
          label: '创建时间',
          prop: 'createdTime'
        },
        {
          label: '支付时间',
          prop: 'payTime'
        },
        {
          label: '支付金额',
          render: (h, scope) => {
            return (
              <span>￥{scope.row.payMoney}</span>
            )
          }
        },
        {
          label: '状态',
          render: (h, scope) => {
            return (
              <span>{scope.row.payStatus == 1 ? '成功' : '失败'}</span>
            )
          }
        }
      ],
      columnAfterSale: [
        {
          type: 'selection'
        },
        {
          label: '商品信息',
          prop: 'authListStr'

        }, {
          label: '单价/数量',
          prop: 'updatedTime'
        },
        {
          label: '小计',
          prop: 'updatedTime'
        },
        {
          label: '其他信息',
          prop: 'updatedTime'
        }
      ],

      page: {
        pageNo: 1,
        pageSize: 10,
        totalNum: 0,
        currentPage: 1
      },
      detailType: '',
      payStatus: '', // 在线支付
      parArray: [],
      parArrayTwo: [],
      auditState: false,
      reallyName: '',
      modifyOrder: true,
      records: [],
      afterSaleInfo: {},
      saleAfter: '',
      afterSale: '',
      afterRecords: [],
      backInfo: {},
      backInfo1: {},
      dictionaries: {},
      time: 0,
    }
  },
  created() {
    this.orderId = this.$route.query.id
    this.orderNo = this.$route.query.orderNo
    this.getOrderStatus()// 订单信息状态节点
    this.getOrderDetail()// 获取订单信息
    this.getBackInfo1()
    this.getDictionaries('courier_company')
    this.getDictionaries('order_status_logistics')
    this.getList()
  },
  methods: {
    rowClick(row) {
      this.radioIdSelect = row.id
      this.addressInfo.name = row.name
      this.addressInfo.phone = row.phone
      this.addressInfo.address = row.address
    },
    getList() {
      this.axios.get('/inflowReturnAddress/addressList')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.gridData = res.data
          }
        })
    },
    submit() {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          if (this.title == '填写退货单号') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/logistics/addLogistics', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getOrderStatus()
                this.getReturnInfo1()
              }

            })
          } else if (this.title == '寄出换货') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/delivery', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getOrderStatus()
                this.getReturnInfo1()
              }

            })
          } else {
            let type = 0
            if (this.title == '修改退货单号') {
              type = 1
            } else {
              type = 2
            }
            let data = {
              logisticsType: type,
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/logistics/updateLogisticsNo', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getOrderStatus()
                this.getReturnInfo1()
              }

            })
          }
        } else {
          return false;
        }
      });

    },
    submitInfo() {
      if (this.time == 0) {
        this.time = 10; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);

        if (this.typeI == 'user') {
          let data = {
            id: this.orderId
          }
          this.axios.post('/orders/after/logistics/userConfirm', data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '收货成功'
              })
              this.isInfo = false
              this.getOrderDetail()
              this.getAfterOrderStatus()
              this.getReturnInfo1()
            }
          })
        } else {
          let data = {
            id: this.orderId
          }
          this.axios.post('/orders/after/logistics/confirm', data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '收货成功'
              })
              this.isInfo = false
              this.getOrderDetail()
              this.getAfterOrderStatus()
              this.getReturnInfo1()
            }
          })
        }
      } else {
        console.log('目前按钮事件不允许被触发');
      }

    },
    stock(type) {
      this.isInfo = true
      this.typeI = type
    },
    outGoods(type) {
      if (type == 'delivery') {
        this.title = '寄出换货'
        this.dialogVisible = true
      } else if (type == 'hedit') {
        this.title = '修改换货单号'
        this.dialogVisible = true
        this.dialogForm.logisticsNumber = this.orderMessage.logisticsNumber
        this.dialogForm.logisticsCompany = this.orderMessage.logisticsCompany
      } else if (type == 'fedit') {
        this.title = '填写退货单号'
        this.dialogVisible = true
      } else {
        this.title = '修改退货单号'
        this.dialogVisible = true
        this.dialogForm.logisticsNumber = this.orderMessage.logisticsNumber
        this.dialogForm.logisticsCompany = this.orderMessage.logisticsCompany
      }
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    look(src) {
      console.log(src)
      this.dialogVisible1 = true
      this.dialogImageUrl = src
    },
    back() {
      this.$router.go(-1)
    },
    getBackInfo1() {
      let data = {
        id: this.orderId,
      }
      this.axios.get('/orders/after/getReturnLogistics', { params: data }).then(res => {
        if (res.code == 0) {
          this.backInfo1 = res.data
          console.log(this.backInfo)
        }
      })
    },
    getBackInfo() {
      if (this.orderMessage.status == 6 || this.orderMessage.status == 8) {
        let data = {
          id: this.orderId,
        }
        this.axios.get('/orders/after/getPostLogistics', { params: data }).then(res => {
          if (res.code == 0) {
            this.backInfo = res.data
            console.log(this.backInfo)
          }
        })
      } else {
        let data = {
          id: this.orderId,
        }
        this.axios.get('/orders/after/getReturnLogistics', { params: data }).then(res => {
          if (res.code == 0) {
            this.backInfo = res.data
            console.log(this.backInfo)
          }
        })
      }

    },
    submitApply() {
      let data = {
        id: this.orderId,
        status: this.status,
        remark: this.remark,
        name: this.addressInfo.name,
        phone: this.addressInfo.phone,
        address: this.addressInfo.address
      }
      this.axios.post('/orders/after/audit', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isApply = false
          this.getOrderStatus()// 订单信息状态节点
          this.getOrderDetail()// 获取订单信息
        }
      })
    },
    //获取运营订单-订单详情
    afterGetInfo() {
      let params = {
        orderNo: this.orderNo
      }
      console.log(params)
      this.$api.afterGetInfo(params)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.afterSaleInfo = res.data;
          }
        })
    },
    // 查询审批进度
    getHistory() {
      this.axios
        .post('/neworder/process/task/getHistory', {
          busId: this.orderNo,
          funcCode: '1',
          headers: {
            isLoading: false
          }
        })
        .then((res) => {
          console.log(res, 'res')

          if (res.code === 0) {
            this.records = []
            const shenheName = res.data.records[res.data.records.length - 1].userName
            if (shenheName.indexOf(this.reallyName) >= 0) {
              this.auditState = true
            } else {
              this.auditState = false
            }
            res.data.records.forEach(item => {
              console.log(item, 'item')
              if (item.resultFlag != '-1') {
                this.records.push(item)
              }
            })
            console.log(this.records, 'this.records')
          } else {
            this.auditState = false
          }
        })
    },
    // 申请售后单选
    getCurrentRow(row) {
      this.multipleSelectionList = row
      this.serviceId = row.id
      this.afterMoney = row.subtotal
    },
    // 发货
    dialogSubmitwuliu(wuliu) {
      this.$refs[wuliu].validate((valid) => {
        if (valid) {
          const data = {
            orderNo: this.orderNo,
            commWarehouseId: this.wuliu.warehouse,
            logisticsCompany: this.wuliu.company,
            logisticsNumber: this.wuliu.odd
          }
          this.$api.updateLogistics(data).then((res) => {
            if (res.code == 0) {
              this.$message.success('发货成功！')
              this.dialog.visible = false
              this.getOrderStatus()
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          return false
        }
      })
    },
    // 出货仓库列表
    getCommWarehouse() {
      const params = { pageNo: 1, pageSize: 10000 }
      this.$api.commWarehouse(params).then((res) => {
        this.commWarehouseList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 备货
    stockUp() {
      this.$confirm('是否备货已选中的订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          ids: [this.orderNo]
        }
        this.$api.logisticsDoArrange(data).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.getOrderStatus()
          }
        })
      }).catch(() => {

      })
    },
    // 监听选择审核是否通过
    handlerSelect(e) {
      if (e == 2) {
        this.cause = ''
      }
    },
    // 审核确定
    handlerAuditsubmit() {
      if (this.selectShenhe == 3 && this.cause == '') {
        return this.$message.warning('请填写审核不通过原因！')
      }
      if (this.selectShenhe) {
        const data = {
          orderNo: [this.orderNo],
          resultFlag: this.selectShenhe,
          reason: this.cause
        }
        this.$api.afterDoApprove(data).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.dialogToo.visible = false
            this.getOrderStatus()
            this.getProcess()
          }
        })
      }
    },
    // 订单信息状态节点
    getOrderStatus() {
      const data = {
        id: this.orderId
      }
      this.axios.get('/orders/after/getStatus', { params: data }).then(res => {
        if (res.code == 0) {
          this.statusNode = res.data
        }
      })
    },
    // 获取订单信息
    getOrderDetail() {
      console.log('获取订单信息')
      this.orderAfterDetailList1 = []
      this.orderAfterDetailList2 = []
      const data = {
        id: this.orderId
      }
      this.axios.get('/orders/after/getOrderAfterDetail', {
        params: data
      }).then(res => {
        if (res.code == 0) {
          this.orderMessage = res.data;
          res.data.orderAfterDetailList.forEach(item => {
            if (item.goodsType != 3) {
              this.orderAfterDetailList1.push(item)
            } else {
              this.orderAfterDetailList2.push(item)
            }
          })
          if (res.data.afterImages) {
            this.imgs = res.data.afterImages.split(',')
          }

          if (this.orderMessage.afterType != 0) {
            this.getBackInfo()
          }

        }
      })
    },
    // 获取订单购买信息
    getBuyInfo() {
      const data = {
        id: this.orderId
      }
      this.$api.getBuyInfo(data).then(res => {
        if (res.code == 0) {
          console.log(res.data, '获取订单购买信息')
          this.buyMessage = res.data
        }
      })
    },
    // （关闭订单）订单状态信息查询
    getCloseStatus() {
      const data = {
        id: this.orderId
      }
      this.$api.getCloseStatusByOrderId(data).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_main_close_reason.length !== 0 && res.data.closeReason) {
            res.data.cause = this.dictionaries.order_main_close_reason.find(e => { return e.dictId == res.data.closeReason }).dictName
          }
          this.closeMessage = res.data
        }
      })
    },
    // 交易记录
    byOrderIdList() {
      const params = {
        orderId: this.orderId
      }
      this.$api.byOrderIdList(params).then(res => {
        if (res.code == 0) {
          res.data.map((item) => {
            if (this.dictionaries.order_pay_type.length !== 0) {
              item.payTypes = this.dictionaries.order_pay_type.find(e => { return e.dictId == item.payType }).dictName
            }
          })
          this.transactionRecord = res.data
        }
      })
    },
    // 获取订单商品信息
    getOrderGoodsInfo() {
      const data = {
        id: this.orderId
      }
      this.$api.getOrderGoodsInfo(data).then(res => {
        if (res.code == 0) {
          res.data.forEach((item) => {
            this.totalPrices = Number(this.totalPrices) + Number(item.subtotal)
            this.totalQuantity += item.quantity
            if (item.status == 0) {
              item.statusCn = '无售后'
            } else if (item.status == 1) {
              item.statusCn = '售后进行中'
            } else if (item.status == 2) {
              item.statusCn = '售后完成'
            } else if (item.status == 3) {
              item.statusCn = '部分售后'
            } else if (item.status == 4) {
              item.statusCn = '售后已关闭'
            } else {
              item.statusCn = ''
            }
          })
          this.goodsMessage = res.data
          console.log(this.goodsMessage, 'this.goodsMessage')
          const tempArr = []
          res.data.forEach(item => {
            // if(item.subsetStatus && item.subsetStatus.indexOf('售后中') > -1){
            if (item.status == 0 || item.status == null) { tempArr.push(item) }
          })
          this.goodsListDialog = [...tempArr]
          console.log('this.orderMessage.orderType==', this.orderMessage.orderType)
          if (this.orderMessage.orderType == '6') {
            let specHtml = '';
            res.data.forEach(item => {
              specHtml += '<p style="line-height:20px">' + item.goodsName + ' ' + item.goodsSkuName + '*' + item.quantity + '</p>'

            })
            specHtml = '<div style="background:#F5F8FF;padding:0 4px;">' + specHtml + '</div>';
            let goodsTitle = '<p style="font-weight:bold;margin-bottom:10px">' + this.orderMessage.giftPackageName + '</p>';
            let giftPackageCode = '<p style="color:#999999;margin-top:10px;">' + '礼包编码：' + this.orderMessage.giftPackageCode + '</p>'
            specHtml = '<div style="font-size:14px">' + goodsTitle + specHtml + giftPackageCode + '</div>';
            let arr = [
              {
                goodsName: specHtml,
                unitPrice: this.orderMessage.giftPackagePrice,
                quantity: this.orderMessage.giftPackageNum,
                amountPaid: this.orderMessage.receivedAmount,
                subtotal: ''
              }
            ]
            console.log(arr)
            this.goodsMessage = arr;
          }
        }
      })
    },
    // （审批结果信息）订单状态信息查询
    getProcess() {
      const data = {
        orderNo: this.orderNo
      }
      this.$api.getProcessByOrderId(data).then(res => {
        if (res.code == 0) {
          this.auditStatus = res.data
          console.log(this.auditStatus, 'auditStatus')
        }
      })
    },
    // 重新提交订单
    getResubmitOrder() {
      const data = {
        id: this.orderId
      }
      this.$api.resubmitOrder(data).then(res => {
        if (res.code == 0) {
        }
      })
    },
    // 订单支付
    getOnlinePay() {
      const data = {
        orderId: this.orderId,
        receivedAmount: 100
      }
      this.$api.onlinePay(data).then(res => {
        if (res.code == 0) {
        }
      })
    },
    // 发货
    shipments() {
      this.wuliu.warehouse = ''
      this.wuliu.company = ''
      this.wuliu.odd = ''
      this.dialog.type = 'shipmentsCode'
      this.dialog.title = '发货'
      this.dialog.width = '450px'
      this.dialog.visible = true
      this.$nextTick(() => {
        this.$refs['wuliu'].resetFields()
      })
    },
    // 交易记录按钮
    tradinRecord() {
      this.dialogAfterSale.visible = true
      this.dialogAfterSale.title = '交易记录'
      this.dialogAfterSale.type = 'record'
      this.dialogAfterSale.width = '800px'
      this.byOrderIdList()
    },
    // 售后弹框列表多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 新增收货地址
    addAddress(type, row) {
      if (this.dialog.type == 'addressAmend') {
        this.dialog.visible = false
        this.dialog.type = 'addAddress'
        this.dialog.title = '新增地址'
        this.dialog.visible = true
        this.dialog.width = '450px'
        this.form.userName = ''
        this.form.phone = ''
        this.form.detailedAddress = ''
        this.form.addressValue = ''
        this.form.isDefault = 0
        this.form.provinceCode = ''
        this.form.cityCode = ''
        this.form.regionCode = ''
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    },

    // 编辑/修改提交数据
    dialogSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialog.title == '编辑') {
            const data = {
              userId: this.orderMessage.customerId,
              userName: this.form.userName,
              phone: this.form.phone,
              provinceCode: this.form.provinceCode, // 省
              cityCode: this.form.cityCode, // 市
              regionCode: this.form.regionCode, // 区
              detailedAddress: this.form.detailedAddress,
              isDefault: this.form.isDefault,
              id: this.rowId
            }
            const that = this
            // 获取当前时间的时间戳
            const now = new Date().valueOf()
            // 第一次点击
            if (this.lastTime == 0) {
              this.$api.categoryEditaddress(data).then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功')
                  this.dialog.visible = false
                  this.shippingAddressList()
                }
              }).catch((err) => {
                console.log(err)
              })
              that.lastTime = now
            } else {
              if ((now - that.lastTime) > 2000) {
                // 重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
                that.lastTime = now
                this.$api.categoryEditaddress(data).then((res) => {
                  if (res.code == 0) {
                    this.$message.success('修改成功')
                    this.dialog.visible = false
                    this.shippingAddressList()
                  }
                }).catch((err) => {
                  console.log(err)
                })

                // 添加自己要调用的方法
              } else {
                console.log('不触发')
              }
            }
          } else {
            const data = {
              userId: this.orderMessage.customerId,
              userName: this.form.userName,
              phone: this.form.phone,
              provinceCode: this.form.provinceCode, // 省
              cityCode: this.form.cityCode, // 市
              regionCode: this.form.regionCode, // 区
              detailedAddress: this.form.detailedAddress,
              isDefault: this.form.isDefault
            }
            const that = this
            // 获取当前时间的时间戳
            const now = new Date().valueOf()
            // 第一次点击
            if (this.lastTime == 0) {
              this.$api.categoryAddaddress(data).then((res) => {
                if (res.code == 0) {
                  this.$message.success('新增成功')
                  this.dialog.visible = false
                  this.shippingAddressList()
                }
              }).catch((err) => {
                console.log(err)
              })
              that.lastTime = now
            } else {
              if ((now - that.lastTime) > 2000) {
                // 重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
                that.lastTime = now
                this.$api.categoryAddaddress(data).then((res) => {
                  if (res.code == 0) {
                    this.$message.success('新增成功')
                    this.dialog.visible = false
                    this.shippingAddressList()
                  }
                }).catch((err) => {
                  console.log(err)
                })

                // 添加自己要调用的方法
              } else {
                console.log('不触发')
              }
            }
          }
        } else {
          return false
        }
      })
    },
    // 地区修改
    onChangeAddress(val) {
      const addressOptions = this.addressOptions
      for (let i = 0; i < val.length; i++) {
        if (i === 0) {
          this.form.provinceCode = addressOptions[val[0]].label
          continue
        }
        if (i === 1) {
          this.form.cityCode = addressOptions[val[0]].children[val[1]].label
          continue
        }
        if (i === 2) {
          this.form.regionCode = addressOptions[val[0]].children[val[1]].children[val[2]].label
          continue
        }
      }
    },
    // 初始化地区数据
    trimAddressData() {
      const arr = []
      for (const province in addressData) {
        const childrenCity = []
        for (const city in addressData[province]) {
          const childrenArea = []
          addressData[province][city].forEach((e, i) => {
            childrenArea.push({ title: '市区', label: e, value: i })
          })
          childrenCity.push({ title: '城市', label: city, children: childrenArea, value: city })
        }
        arr.push({ title: '省份', label: province, children: childrenCity, value: province })
      }
      // 修改 value 值
      arr.forEach((e, i) => {
        e.value = i
        e.children.forEach((ee, ii) => {
          ee.value = ii
        })
      })
      this.addressOptions = arr
    },
    // 编辑按钮
    dialogEdit(type, row) {
      // this.$refs.addCustomers.clickData()
      this.form.addressValue = []
      this.addressOptions.find(province => {
        if (province.label == row.provinceCode) {
          this.form.addressValue.push(province.value)

          province.children.find((city) => {
            if (city.label == row.cityCode) {
              this.form.addressValue.push(city.value)
            }
            city.children.find((district) => {
              if (district.label == row.regionCode) {
                this.form.addressValue.push(district.value)
              }
            })
          })
        }
      })
      this.dialog.type = 'addAddress'
      this.dialog.title = '编辑'
      this.dialog.width = '450px'
      this.dialog.visible = true
      this.form.userName = row.userName
      this.form.phone = row.phone
      this.form.detailedAddress = row.detailedAddress
      this.form.isDefault = row.isDefault
      this.rowId = row.id
      this.form.provinceCode = row.provinceCode
      this.form.cityCode = row.cityCode
      this.form.regionCode = row.regionCode
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    // 添加备注确定按钮
    confirm() {

    },
    // 审核按钮
    handlerAudit() {
      this.dialogToo.type = 'audit'
      this.dialogToo.visible = true
      this.dialogToo.title = '审核'
      this.dialogToo.width = '600px'
    },
    // 生成收款码确定弹框
    confirmSelectPay() {
      if (this.dialogToo.type == 'selectPay') {
        this.dialogToo.visible = false
        if (this.setPay.payment != 1) {
          this.$message.warning('请选择支付方式！')
        }
        if (this.setPay.payment == 1) { // 1表示在线支付
          this.dialogToo.type = 'payMoney'
          this.dialogToo.visible = true
          this.dialogToo.title = '在线支付'
          this.dialogToo.width = '640px'
          this.paymentAmount = 0.00
        }
      }
    },
    onlinePayment() {
      const data = {
        orderId: this.orderId,
        receivedAmount: this.paymentAmount
      }
      this.$api.onlinePay(data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功！')
          this.dialogToo.visible = false
        }
      })
    },
    // 修改收货地址
    amendAddress() {
      this.dialog.visible = true
      this.dialog.title = '修改收货地址'
      this.dialog.type = 'addressAmend'
      this.dialog.width = '1274px'
      this.shippingAddressList()
    },
    // 收货地址列表数据
    shippingAddressList() {
      const params = {
        id: this.orderMessage.customerId// 用户id
      }
      this.$api.categoryShippingAddress(params).then((res) => {
        if (res.code == 0) {
          this.siteDataList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 修改收货地址弹框列表里面的使用地址
    employ(row) {
      const data = {
        id: this.orderId, //	订单物流id	body	true	integer(int64)
        postAddress: row.provinceCode + row.cityCode + row.regionCode + row.detailedAddress, //	收货地址	body	true	string
        postCityCode: row.cityCode ? row.cityCode : '', //	收货市级code	body	true	string
        postContact: row.phone, //	收货人联系方式	body	true	string
        postDetailedAddress: row.detailedAddress, //	收货详细地址	body	true	string
        postName: row.userName, //	收货人	body	true	string
        postProvinceCode: row.provinceCode ? row.provinceCode : '', //	收货省级code	body	true	string
        postRegionCode: row.regionCode ? row.regionCode : '' //	收货区级code	body	true	string
      }
      this.$api.updateOrderAddress(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('使用成功！')
          this.dialog.visible = false
          this.getBuyInfo()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 是否设置为默认地址
    defaultSite(id) { this.setCategoryDefaultSite(id) },
    // 设置默认地址
    setCategoryDefaultSite(id) {
      const params = {
        id: id
      }
      this.$api.categoryDefaultSite(params).then((res) => {
        if (res.code == 0) {
          this.$message.success('设置成功！')
          this.shippingAddressList()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除地址
    dialogDelete(id) {
      this.$confirm('是否删除该地址？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          addressId: id,
          userId: this.buyMessage.id
        }
        this.$api.categoryDeleteAddress(params).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功！')
            this.shippingAddressList()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 修改收货地址
    updateOrderAddress() {
      const data = {
        id: this.orderId
      }
      this.$api.updateOrderAddress(data).then(res => {
      })
    },
    // 生成收款码
    moneyReceiving(e) {
      this.setPay.payment = '0'
      this.setPay.payDefault = false
      this.dialogToo.visible = true
      this.dialogToo.title = '选择支付方式'
      this.dialogToo.type = 'selectPay'
      this.dialogToo.width = '640px'
      const setPayPayment = localStorage.getItem('setPayPayment')
      const setPayPayDefault = localStorage.getItem('setPayPayDefault')
      if (setPayPayment && setPayPayDefault) {
        this.setPay.payment = '1'
        this.setPay.payDefault = true
      } else {
        this.setPay.payment = '0'
        this.setPay.payDefault = false
      }
    },
    // 查看物流，添加备注关闭弹框
    handleClose() {
      this.dialog.visible = false
    },
    // 修改地址
    handleCloseToo() {
      this.dialogToo.visible = false
      this.setPay.payment = ''
      this.payMoney = ''
      this.shenhe = '2'
    },
    // 查看物流按钮
    examine(type) {
      this.dialog.title = '查看物流'
      this.dialog.type = 'logisticsInformation'
      this.dialog.width = '948px'
      this.dialog.visible = true
      this.getlogistics(type)// 查询物流节点信息
    },
    // 物流信息
    getlogistics(val) {
      const data = {
        id: this.orderId,
        logisticsType: val
      }
      this.axios.get('/orders/after/getLogisticsDetail', { params: data }).then(res => {
        if (res.code == 0) {
          res.data.data.map(item => {
            item.year = item.time.split(' ')[0]
            item.dataTime = item.time.split(' ')[1]
          })
          this.logisticsNode = res.data
        }
      })
    },
    // （物流信息）订单状态信息查询
    getExamine() {
      const params = {
        id: this.orderId
      }
      this.$api.getLogisticsStatusByOrderId(params).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_status_logistics.length !== 0 && res.data.status) {
            res.data.statusCn = this.dictionaries.order_status_logistics.find(e => { return e.dictId === res.data.status }).dictName
          }
          if (this.dictionaries.courier_company.length !== 0 && res.data.logisticsCompany) {
            res.data.logisticsCompanyCN = this.dictionaries.courier_company.find(e => { return e.dictId === res.data.logisticsCompany }).dictName
          }
          // console.log(logisticsCompany)
          this.logisticsMessage = res.data
          // this.logisticsMessage.logisticsCompany = logisticsCompany
        }
      })
    },

    // 添加备注按钮
    addRemarkBtn() {
      this.dialog.title = '添加备注'
      this.dialog.type = 'addRemark'
      this.dialog.width = '30%'
      this.dialog.visible = true
      this.remark = ''
      if (this.orderMessage.remarks) {
        this.remark = this.orderMessage.remarks
      }
    },
    // 备注弹框确定
    confirmAddRemark() {
      const data = {
        id: this.orderId,
        remarks: this.remark
      }
      this.$api.updateRemark(data).then(res => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          this.dialog.visible = false
          this.getOrderDetail()
        }
      })
    },
    // 关闭订单按钮
    handlerCloseOrder() {
      this.setCloseOrder = ''
      this.dialogToo.visible = true
      this.dialogToo.title = '关闭订单'
      this.dialogToo.type = 'closeOrder'
      this.dialogToo.width = '500px'
    },
    // 关闭订单确定
    handlerCloseOrderSubmit() {
      let apis
      if (this.orgName == '物流中心') {
        apis = this.$api.wuliuCloseOrder
      } else {
        apis = this.$api.closeOrder
      }
      const data = {
        id: this.orderId,
        closeReason: this.setCloseOrder
      }
      apis(data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.dialogToo.visible = false
          this.getOrderStatus()
        }
      })
    },
    // 选择支付方式
    selectPayment(e) {
      if (e == 1) { // 在线支付
        this.payStatus = e
      }
    },
    // 售后
    handlerAfterSale() {
      // console.log(this.dictionaries.after_sale_reason)
      this.multipleSelection = ''

      this.dialogAfterSale.visible = true
      this.dialogAfterSale.title = '售后'
      this.dialogAfterSale.type = 'afterSale'
      this.dialogAfterSale.width = '1000px'
    },
    // 售后弹框关闭
    handledeleteClose() {
      this.dialogAfterSale.visible = false
      this.$refs['ruleForm'].resetFields()
    },
    handleshouhouClose() {
      this.dialogAfterSale.visible = false
    },
    // 申请售后按钮弹框
    applyDialog() {
      if (this.dialogAfterSale.type == 'afterSale' && this.multipleSelection.length != 0) {
        this.dialogAfterSale.visible = false
        this.dialogAfterSale.type = 'applyAfterSale'
        this.dialogAfterSale.visible = true
        this.dialogAfterSale.title = '售后'
        this.dialogAfterSale.width = '640px'
        this.ruleForm.afterSaleReason = ''
        this.ruleForm.afterType = ''
        this.ruleForm.appendixList = []
        this.ruleForm.customerUserId = ''
        this.ruleForm.orderId = ''
        this.ruleForm.refundExplain = ''
        this.ruleForm.refundMoney = ''
        this.ruleForm.sysUserId = ''
        this.ruleForm.totalNum = ''
      } else {
        this.$message.warning('请选择需要售后的商品！')
      }
    },
    // 售后申请提交
    submitAfterSale(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const idList = []
          const afterDetailList = []
          const dataList = {}
          const skuId = []

          if (this.multipleSelectionList) {
            dataList.goodsId = this.multipleSelectionList.goodsId
            dataList.goodsSkuId = this.multipleSelectionList.goodsSkuId
            afterDetailList.push(dataList)
          }
          const data = {
            afterDetailList: afterDetailList,
            afterSaleReason: this.ruleForm.afterSaleReason, // 售后原因（字典分组：after_sale_reason）	body	true	integer(int32)
            afterType: this.ruleForm.afterType, // 售后类型（字典分组：after_type）	body	true	integer(int32)
            appendixList: this.ruleForm.appendixList, //	退款凭证记录（附件）列表	body	false	array	售后订单退款凭证
            customerUserId: this.buyMessage.userId, //	退货客户id	body	true	integer(int64)
            orderId: this.orderId, //	订单id	body	true	integer(int64)
            refundExplain: this.ruleForm.refundExplain, //	退款说明	body	false	string
            refundMoney: this.ruleForm.refundMoney, //	退款金额	body	true	number
            sysUserId: JSON.parse(sessionStorage.getItem('userInfo')).id, //	跟进客服id	body	true	integer(int64)
            totalNum: afterDetailList.length//	总数量	body	true	integer(int64)
          }
          this.$api.applyAfterSales(data).then(res => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.dialogAfterSale.visible = false
              this.getOrderDetail()
              this.getOrderStatus()
              this.getOrderGoodsInfo()
            }
            setTimeout(_ => {
              this.loading = false
            }, 1000)
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    // 获取上传图片文件的链接
    getUrl(getUrl) {
      const obj = {}
      // obj.afterId = this.orderId
      obj.resourceUrl = this.ImgHttps + getUrl
      obj.url = this.ImgHttps + getUrl
      obj.mainFlag = 0
      this.ruleForm.appendixList.push(obj)
      // if(e.mainImage && e.mainImage.indexOf("http://fenxiao.muruji.com/") !== 0){e.mainImage = this.ImgHttps + e.mainImage}
      // this.ruleForm.appendixList.push({ mainFlag: 0, url: this.ImgHttps + getUrl })
    },
    // 删除当前图片文件的链接（如果接受文件路径是数组时 使用此方法）
    handleRemove(url) {
      const delIndex = this.ruleForm.appendixList.findIndex(e => { return e.url == url })
      this.ruleForm.appendixList.splice(delIndex, 1)
    },
    // 确认收货
    takeDeliveryOfGoods() {
      this.$confirm('是否确认收货？确认收货前，请确认商品已签收！', '确认收货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: this.orderId

        }
        this.$api.serviceConfirmReceipt(data).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.getOrderStatus()
          }
        })
      }).catch(() => {
      })
    },

    // 重新提交
    handlerResubmit() {
      this.$confirm('该订单是否重新提交审核？', '重新提交审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: this.orderId
        }
        this.$api.resubmitOrder(data).then(res => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.getOrderStatus()
            this.getProcess()
          }
        })
      }).catch(() => {

      })
    },
    // 选择支付方式弹框内的设置默认
    selectPayDefault(e) {
      if (this.setPay.payment) {
        if (e == true) {
          localStorage.setItem('setPayPayment', 1)
          localStorage.setItem('setPayPayDefault', true)
        } else {
          localStorage.removeItem('setPayPayment')
          localStorage.removeItem('setPayPayDefault')
        }
      }
    }

  }
}
</script>

<style scoped  lang="scss">
.afterTitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 0px;
  color: #303033;
  opacity: 1;
}

.afterInfo {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #303033;
}

.fontC {
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
}

// .el-form .el-form-item {
//   margin-bottom: -12px;
// }

.surTime {
  width: 10%;
  padding: 10px 10px;

  .surTime-title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303033;
    opacity: 1;
  }

  .surTime-time {
    margin-top: 18px;

    .title {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 18px;
      color: #f63c56;
    }

    .sur-content {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;

      .time {
        width: 36px;
        height: 36px;
        background: #faf0f1;
        opacity: 1;
        border-radius: 3px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 36px;
        color: #f63c56;
        text-align: center;
      }

      .splice {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 36px;
        color: #f63c56;
        text-align: center;
      }
    }
  }
}

.logisticsBtn {
  padding-top: 51px;
}

.boldSize {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.boldSize16 {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
}

.size14 {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

.pass {
  width: 98%;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 2px;
  line-height: 36px;
  padding-left: 12px;
  margin-top: 24px;
  margin-bottom: 100px;

  .price {
    color: #f63c56;
  }
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 14px;
}


@media screen and (max-width: 1280px) {
  .borderWire {
    width: 1px;
    background-color: #ededed;
    margin-top: 4.5% !important;
  }

  .boldSize {
    font-size: 18px !important;
    font-weight: bold;
    color: #333333;
  }

  .boldSize16 {
    font-size: 16px !important;
    font-weight: 400;
    color: #333333;
  }

  .approver {
    margin-top: 10px;
    font-size: 14px !important;
    font-weight: 400;
  }

  .size14 {
    font-size: 14px !important;
    font-weight: 400;
    color: #666666;
  }

  .logisticsBtn {
    padding-top: 51px !important;
  }

  /deep/.el-table th>.cell {
    font-size: 14px !important;
  }

  .contentDetails {
    margin-bottom: 20px;
    padding: 16px 20px !important;
    background-color: #ffffff;
    box-sizing: border-box;

    .contentDetails_item {
      width: 50%;
      height: auto;
    }

    .afterSales {
      width: 120px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #f33f3f;
      opacity: 1;
      border-radius: 4px;
      line-height: 0;
      color: #f33f3f;
    }

    .addressWidth {
      width: 560px !important;
    }

    .details {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;

      .details_item {
        width: auto !important;
        line-height: 40px;

        .details_title {
          width: 85px !important;
          font-size: 14px !important;
          font-weight: 400;
          line-height: 0px;
          color: #999999;
          text-align: right;
          display: inline-block;
        }

        .details_value {
          font-size: 14px;
          font-weight: 400;
          line-height: 0px;
          color: #666666;
          padding-left: 12px;
        }
      }
    }

    .remarkMessage {
      margin-top: 18px;

      .remarkMessage_remark {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .fourteenTitle_buymessage {
        margin-left: 28px !important;
      }

      .remarkMessage_remark_item {
        width: 50%;
        display: flex;
        align-items: center;
        margin-right: 10px;
      }

      .fourteenTitle {
        width: 62px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }

      .fourteenDetails {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }

    .title {
      font-size: 16px !important;
      font-weight: 400;
    }

    .title_too {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-top: 18px;
      padding-left: 28px !important;
    }

    .titleblue {
      display: flex;
      align-items: center;

      &:before {
        display: inline-block;
        content: "";
        width: 4px;
        height: 16px;
        background-color: #2d7edf;
        margin-right: 10px;
      }
    }

    .titleBtn {
      display: flex;
      justify-content: space-between;
    }

    .box {
      padding: 0px 20px !important;
      background: #f5f8ff;
      box-sizing: border-box;
      padding-left: 25px;
    }
  }
}

.contentDetails {
  margin-bottom: 20px;
  padding: 16px 20px;
  background-color: #ffffff;
  box-sizing: border-box;

  .borderWire {
    width: 1px;
    background-color: #ededed;
    margin-top: 0%;
    margin-left: 8%;
    margin-right: 2%;
  }

  .contentDetails_box {
    display: flex;
    justify-content: left;

    .details {
      display: flex;
      margin-top: 10px;
      flex-wrap: wrap;
      // margin-right: 250px;

      .contentDetails_item {
        width: 50%;
        display: flex;
      }

      .details_item {
        min-width: 100px;
        line-height: 40px;

        .details_title {
          width: 82px;
          font-size: 16px;
          font-weight: 400;
          line-height: 0px;
          color: #999999;
          text-align: right;
          display: inline-block;
        }

        .details_value {
          font-size: 16px;
          font-weight: 400;
          line-height: 0px;
          color: #666666;
          padding-left: 12px;
        }
      }
    }
  }

  .afterSales {
    width: 120px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #f33f3f;
    opacity: 1;
    border-radius: 4px;
    line-height: 0;
    color: #f33f3f;
  }

  .addressWidth {
    // width: 560px !important;
  }

  .order_details {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin-top: 10px;

    .blankBox {
      width: 3%;
    }

    .order_details_item {
      // min-width: 255px;
      line-height: 40px;

      .order_details_title {
        width: auto;
        font-size: 14px;
        font-weight: 400;
        line-height: 0px;
        color: #999999;
        text-align: right;
        display: inline-block;
      }

      .order_details_value {
        font-size: 14px;
        font-weight: 400;
        line-height: 0px;
        color: #666666;
        padding-left: 12px;
      }
    }
  }

  .remarkMessage {
    margin-top: 18px;

    .remarkMessage_remark {
      display: flex;
      align-items: center;
    }

    .remarkMessage_remark_item {
      width: 50%;
      display: flex;
      align-items: center;
    }

    .fourteenTitle {
      width: 62px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }

    .fourteenTitle_buymessage {
      width: 62px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-left: 26px;
    }

    .fourteenDetails {
      width: 78%;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      padding-bottom: 0;
      background-color: #f5f8ff;
      margin-left: 10px;
      margin-right: 10px;

      padding-left: 10px;
    }
  }

  .title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 21px;
    color: #303033;
  }

  .title_too {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin-top: 20px;
    // padding-left: 25px;
  }

  .titleblue {
    display: flex;
    align-items: center;

    &:before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 16px;
      background-color: #2d7edf;
      margin-right: 10px;
    }
  }

  .titleBtn {
    display: flex;
    justify-content: space-between;
  }

  .box {
    background: #f5f8ff;
    box-sizing: border-box;
    padding-left: 25px;
  }
}

.fourteenTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.fourteenDetails {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  padding-bottom: 20px;

  .fourteenDetails_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .fourteenDetails_item_title {
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #666666;
    }
  }
}

.fourteenDetails_title {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px;
  margin-top: 20px;
}

.red {
  color: red !important;
}

.total_prices {
  margin-top: 24px;
  display: flex;
  justify-content: right;
  font-size: 16px;
}

.botton_btn {
  margin-top: 18px;
  text-align: left;
  padding-bottom: 18px;

  // padding: 10px 20px 20px 20px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}

.dialogBtn {
  display: flex;
  justify-content: right;
}

.setPayDialogBtn {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;

  .setPay_payment_btn_quxiao {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    opacity: 1;
    border-radius: 4px;
    line-height: 0;
  }

  .setPay_payment_btn_queren {
    width: 120px;
    height: 36px;
    background: #4168e7;
    opacity: 1;
    border-radius: 4px;
    line-height: 0;
    border: 0;
  }
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.dialogBtnright {
  display: flex;
  justify-content: right;

  .setPay_payment_btn_quxiao {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    opacity: 1;
    border-radius: 4px;
    line-height: 0;
  }

  .setPay_payment_btn_queren {
    width: 120px;
    height: 36px;
    background: #4168e7;
    opacity: 1;
    border-radius: 4px;
    line-height: 0;
    border: 0;
  }
}

.fourteen {
  font-size: 14px !important;
}

.addressHeader {
  display: flex;
  justify-content: right;
  align-items: center;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.payMoney {
  background: #f5f8ff;
  padding: 20px;
  margin-bottom: 30px;

  .payMoney_should {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
  }

  .payMoney_already {
    font-size: 16px;
    font-weight: bold;
    color: #4168e7;
    margin-bottom: 10px;
  }

  .payMoney_box {
    display: flex;
    justify-content: right;
    align-items: center;

    .payMoney_money {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      padding-right: 10px;
    }

    .payMoney_mo {
      padding-right: 6px;
      color: #4168e7;
    }
  }

  .payMoney_text {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    display: flex;
    justify-content: right;
    align-items: center;
    margin-top: 15px;

    .payMoney_text_item {
      padding-left: 20px;
    }
  }
}

/deep/.el-input-number__increase {
  right: 0;
}

.audit_title {
  font-weight: bold;
  margin-bottom: 20px;
  font-size: 16px;
}

.audit_textarea {
  margin-top: 10px;

  /deep/.el-textarea__inner {
    margin-top: 13px;
    height: 132px;
  }
}

// 售后弹框
.deletegroup {
  .lb-table {
    border: none;
  }

  /deep/.el-dialog .el-dialog__header {
    background-color: #fff;
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/.el-dialog__body {
    padding: 30px 30px 10px 30px;
  }
}

.demo-ruleForm {
  /deep/.el-textarea__inner {
    height: 132px;
  }

  /deep/.el-form-item__label {
    float: none;
    word-break: break-word;
  }

  /deep/.el-form-item {
    margin-bottom: 10px;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/.el-dialog__body {}
}

.dialogafterSaleClass {
  /deep/.el-dialog .el-dialog__header {
    background-color: #fff;

    .el-dialog__headerbtn .el-dialog__close {
      color: #333333 !important;
    }
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/.el-dialog__body {
    padding: 10px 30px 30px 30px;
  }

  .deletegroup_title {
    display: flex;
    align-items: center;

    .deletegroup_title_item {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .deletegroup_title_blue {
      font-size: 18px;
      font-weight: 400;
      color: #4168e7;
    }
  }
}

/deep/.el-upload .el-upload--picture-card {
  width: 124px;
  height: 124px;
  line-height: 128px;
}

/deep/.el-upload-list__item-thumbnail {
  width: 124px;
  height: 124px;

  img {
    width: 124px;
    height: 124px;
  }
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 124px;
  height: 124px;
}

.approver {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
}

// 白色背景蓝色字体按钮
.whiteBtn {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  color: #4168e7;
}

/deep/.el-table th>.cell {
  text-align: unset;
  font-size: 16px;
}

.fontWeight {
  font-weight: bold !important;
}

.gift {
  display: inline-block;
  text-align: center;
  width: 54px;
  height: 24px;
  background: #feebeb;
  border-radius: 4px;
  margin-left: 25px;
  font-size: 14px;
  font-weight: 400;
  color: #f33f3f;
  line-height: 23px;
  box-sizing: border-box;
}

.Manner {
  font-size: 16px;
  font-weight: bold;
  color: #4168e7;
  margin-top: 12px;
}

.vipName {
  background-color: #e3edff;
  padding: 2px 12px;
  border-radius: 18px;
  font-size: 14px;
  color: #333333;
  margin-left: 16px;
}

.about-item-box {
  display: flex;
  align-items: center;
  font-size: 16px;
  justify-content: space-between;
  color: #666666;
}

.about-item {
  flex: 1;
  text-align: center;
  font-size: 16px;
}

.about-title {
  color: #333333;
  font-weight: bold;
}

.about-item-title-box {
  height: 45px;
  line-height: 45px;
  background-color: #f8f8f9;
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
}

.about-item-info-box {
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  // line-height: 65px;
}

.about-tipsbox {
  display: flex;
  align-items: center;
}

.about-tips {
  width: 16px;
  height: 16px;
  background-color: #f2a626;
  color: white;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  border-radius: 50%;
  margin-left: 4px;
  font-size: 12px;
}

.saleAfterType {
  background-color: #f5f8ff;
  border-radius: 12px;
  padding: 0 8px;
  margin-left: 8px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #666666;
}
</style>
